import React, { useState, useEffect } from "react";
import { useModalManager } from "../../hooks/useModalManager.js";
import BuyTrafficModal from "../../Components/BuyTrafficModal/BuyTrafficModal.module.js";
import UserCard from "../../Components/UserCard/UserCard.module.js";
import BatchRenewModal from "../../Components/BatchRenewModal/BatchRenewModal.module.js";
import LineChart from "../../Components/LineChart/LineChart.module.js";
import AutoRenewModal from "../../Components/AutoRenewModal/AutoRenewModal.module.js";
import TransactionModal from "../../Components/TransactionModal/TransactionModal.module.js";

import PricingModal from "../../Components/PricingModal/Pricing.module.js";
import { apiUrl } from "../../Constants/Constants.js";
// import FetchWithToken from "./Components/FetchWithToken/FetchWithToken";
import { AuthContext } from "../../Constants/AuthProvider.js";
import { ConfirmationModalContext } from "../../fautures/ConfirmationModalProvider.js";
import AddCreditModal from "../../Components/AddCreditModal/AddCreditModal.module.js";
import ConfirmationModal from "../../Components/ConfirmationModal/ConfirmationModal.module.js";
import { useFetchWithToken } from "../../Components/FetchWithToken/FetchWithToken.js";

import Loading from "../../Components/Loading/Loading.module.js"; // کامپوننت لودینگ
import { toast } from "react-toastify";
import VidPlayer from "../../Components/VidPlayer/VidPlayer.module.js";
import Menu from "../../Components/Menu/Menu.module.js";
import WaitingPaymentAccount from "../../Components/WaitingPaymentAccount/WaitingPaymentAccount.module.js";
import PayReservedModal from "../../Components/PayReservedModal/PayReservedModal.module.js";
import ServerStatusModal from "../../Components/ServerStatus/ServerStatusModal.module.tsx";
import NewConnectionProfile from "../../Components/NewConnectionProfile/NewConnectionProfile.module.js";
import ReferralManage from "../../Components/ReferralManage/ReferralManage.module.js";
const MainPage = ({ loadingShow, setLoadingShow }) => {
  const modalList = [
    "batchRenew",
    "autoRenew",
    "transaction",
    "pricing",
    "trafficBuy",
    "addCredit",
    "confirm",
    "payReserved",
  ];
  const { openModal, closeModal, isOpen, getPayload } =
    useModalManager(modalList);

  const { loading, fetchWithToken } = useFetchWithToken();
  const [receivedData, setReceivedData] = useState([]);
  const { onLogout } = React.useContext(AuthContext);
  const [isWaitingShown, setIsWaitingShown] = useState(false);
  const { description, openUpModal, confirmTitle, payloadConfirm, toDo } =
    React.useContext(ConfirmationModalContext);

  useEffect(() => {
    getInfo();
  }, []);

  useEffect(() => {
    setLoadingShow(loading);
  }, [loading]);
  // const checkEmergency = (data) => {
  //   if (data.isEmergencyActive) {
  //     document.documentElement.style.setProperty(
  //       "--main-gradient",
  //       "linear-gradient(to right, #805151, #710000)"
  //     );
  //     document.documentElement.style.setProperty(
  //       "--body-gradinet",
  //       "linear-gradient(to right, #d44040, #a01010)"
  //     );
  //     document.documentElement.style.setProperty(
  //       "--menu-gradient",
  //       "linear-gradient(to right, #2f0808, #720000)"
  //     );
  //     document.documentElement.style.setProperty("--main-color", "white");
  //   } else {
  //     document.documentElement.style.setProperty(
  //       "--main-gradient",
  //       "linear-gradient(145deg, #ffffff, #d1e6f9)"
  //     );
  //     document.documentElement.style.setProperty(
  //       "--body-gradinet",
  //       "linear-gradient(to right, #e0f7ff, #ffffff)"
  //     );
  //     document.documentElement.style.setProperty(
  //       "--menu-gradient",
  //       "linear-gradient(145deg, #ffffff, #c2e2f2)"
  //     );
  //     document.documentElement.style.setProperty("--main-color", "black");
  //   }
  // };
  const getInfo = () => {
    fetchWithToken(apiUrl + "user/dashboard-details", {
      method: "GET",
    }).then((data) => {
      setReceivedData(data.data);

      if (data.status === "401") {
        onLogout();
      }
    });
  };
  const fetchAccounts = async () => {
    return receivedData.profiles;
  };

  const fetchTransactions = async () => {
    return receivedData.bills;
  };

  const plans = receivedData.packages || [];

  const handleAddCredit = (amount) => {
    // درخواست به سرور برای افزایش اعتبار
  };

  const activeEmergencyMode = () => {
    const former = new FormData();
    fetchWithToken(
      apiUrl + "user/active-emergency-connection",
      {
        method: "POST",
      },
      former
    ).then((data) => {
      if (data.status === "200") {
        if (data.data.status !== "200") {
          toast.error(data.data.message);
        } else {
          toast.success(data.data.message);
        }

        closeModal("confirm");
        getInfo();
      } else if (data.status === "6") {
        toast.error(data.data);
      }

      // setReceivedData(data.data);

      if (data.status === "401") {
        onLogout();
      }
    });
  };

  const activeEmergencyModeConfirm = () => {
    // openModal("confirm");
    // setConfirmationTitle("فعالسازی اتصال اضطراری");
    // let texter = <>آیا مطمئن هستید که میخواید اتصال اضطراری را فعال نمایید؟</>;
    // setHandleText(texter);
    // setHandleConfirm(() => activeEmergencyMode);
  };
  return (
    <>
      {receivedData?.profiles?.length === 0 && (
        <WaitingPaymentAccount
          reserveds={receivedData?.reservedAccounts}
          modalOpener={openModal}
          onPresenceChange={setIsWaitingShown}
        />
      )}

      {receivedData?.profiles?.length !== 0 ? (
        <>
          <Menu
            receivedData={receivedData}
            modalOpener={openModal}
            onLogout={onLogout}
          />
          <WaitingPaymentAccount
            reserveds={receivedData?.reservedAccounts}
            modalOpener={openModal}
            onPresenceChange={setIsWaitingShown}
          />
          {/* <div className="howtowork">
            <div className="howtoworktitle">اطلاعیه</div>
            <div className="descers">
              قابل توجه همراهان گرامی!
              <br />
              به دلیل بروزرسانی و تغییر سیستم عامل سرور اصلی، اکانت های شما تا
              مدت کوتاهی از دسترس خارج خواهد شد.
              <br />
              موقتا برای شما پروفایل های تست قرار داده شده،‌ این پروفایل ها
              برروی سرور دوم در حال اجرا هستند، تا پایان بروزرسانی و اعمال کلیه
              اکانت های شما عزیزان برروی سیستم عامل جدید، میتوانید از پروفایل
              های تستی (با قابلیت تغییر لوکیشن) استفاده نمایید.
              <br />
              با تشکر از صبر و شکیبایی شما
            </div>
          </div> */}

          {receivedData?.referral?.referralStatus === true && (
            <ReferralManage
              account={receivedData}
              loadingShow={setLoadingShow}
            />
          )}
        </>
      ) : (
        <div className="downmobile-fix"></div>
      )}
      {/* <div className="howtowork">
        <div className="howtoworktitle">نحوه استفاده</div>
        <div className="descers">
          نحوه ی افزودن پروفایل و استفاده از اکانت ها برای سیستم عامل های
          اندروید، آی او اس، مک و ویندوز برای شما عزیزان قرار گرفت.
        </div>
        <div className="partofvids">
          <VidPlayer src="./vids/ios-irluxe.MP4" title="ios" />
          <VidPlayer src="./vids/android-irluxe.mp4" title="android" />
          <VidPlayer src="./vids/winmac.mp4" title="windows & mac" />
        </div>
      </div> */}
      {/* <div className="top-cards">
        <div className="top-options">
          <LineChart />
        </div>
      </div> */}
      {/* <div className="howtowork">
        <div className="howtoworktitle">اطلاعیه</div>
        <div className="descers">
          با سلام و احترام خدمت کاربران گرامی،
          <br />
          تمامی سرویس‌های ایرلوکس، پس از عبور امن از فایروال‌های سخت‌گیر زیرساخت
          ایران، به سرورهای قدرتمند و رمزنگاری‌شده‌ی Proton VPN متصل می‌شوند.
          <br />
          این معماری پیشرفته مزایای زیر را فراهم می‌کند:
          <br />
          ✅ دور زدن موثر فیلترینگ و محدودیت‌ها با عبور از سد فایروال‌های داخلی،
          کاربران تجربه‌ای بدون اختلال و پایدار خواهند داشت.
          <br />✅ حریم خصوصی واقعی با ترافیک رمزنگاری‌شده اتصال به سرورهای
          بین‌المللی Proton VPN باعث می‌شود هیچ نهاد یا واسطه‌ای نتواند به
          محتوای ترافیک شما دسترسی پیدا کند.
          <br />✅ سرعت و پایداری فوق‌العاده استفاده از زیرساخت خارج از کشور با
          استانداردهای جهانی باعث افزایش سرعت و کاهش قطعی می‌شود.
          <br />✅ مصونیت در برابر نظارت داخلی ترافیک شما از مبدا به گونه‌ای
          رمزنگاری و منتقل می‌شود که قابل شنود یا بررسی نیست.
          <br />✅ همگام با جدیدترین پروتکل‌های دور زدن فایروال، ایرلوکس هر روز
          خود را با جدیدترین روش‌ها، پروتکل‌ها و تکنولوژی‌های عبور از فیلترینگ
          به‌روز می‌کند؛ تا همیشه یک قدم جلوتر از محدودیت‌ها باشید.
        </div>
      </div> */}
      {/* <div className="top-cards">
        <div className="top-options">
          <LineChart />
        </div>
      </div> */}
      <div className="cards-container">
        {receivedData?.profiles?.map((user) => (
          <UserCard
            modalOpener={openModal}
            onMainPage={true}
            countryInfo={receivedData?.countryInfo}
            key={user.id}
            item={user}
            onBuyTraffic={() => openModal("trafficBuy", user.id)}
            getInfo={getInfo}
            loadingShower={setLoadingShow}
          />
        ))}
      </div>
      <PayReservedModal
        isOpen={isOpen("payReserved")}
        onClose={() => closeModal("payReserved")}
        userWallet={receivedData.remainingWallet}
        reservedAccount={getPayload("payReserved")}
        getInfo={getInfo}
        loadingShow={setLoadingShow}
      />
      {receivedData?.profiles?.length !== 0 ? (
        <>
          <BatchRenewModal
            isOpen={isOpen("batchRenew")}
            onClose={() => closeModal("batchRenew")}
            fetchAccounts={fetchAccounts}
            userWallet={receivedData.remainingWallet}
            setAutoRenewModalOpen={() => openModal("autoRenew")}
            loadingShow={setLoadingShow}
          />

          <TransactionModal
            isOpen={isOpen("transaction")}
            onClose={() => closeModal("transaction")}
            fetchTransactions={fetchTransactions}
          />
          <BuyTrafficModal
            isOpen={isOpen("trafficBuy")}
            onClose={() => closeModal("trafficBuy")}
            account={getPayload("trafficBuy")}
            receivedData={receivedData}
            getInfo={getInfo}
            loadingShow={setLoadingShow}
            userWallet={receivedData.remainingWallet}
          />
          <PricingModal
            isOpen={isOpen("pricing")}
            onClose={() => closeModal("pricing")}
            plans={plans}
          />
          <AddCreditModal
            isOpen={isOpen("addCredit")}
            onClose={() => closeModal("addCredit")}
            onAddCredit={handleAddCredit}
            loadingShow={setLoadingShow}
          />
        </>
      ) : (
        <>
          {!isWaitingShown && (
            <NewConnectionProfile
              getInfo={getInfo}
              loadingShow={loadingShow}
              setLoadingShow={setLoadingShow}
            />
          )}
        </>
      )}
    </>
  );
};

export default MainPage;
